export default __webpack_public_path__ + "static/media/icon_log_on.c84f7bef.svg";